import React from "react";
import { Link } from "react-router-dom";
import ListGroup from "react-bootstrap/ListGroup";
import Tab from "react-bootstrap/Tab";
// import { Container, Row, Col, Table } from "react-bootstrap";

export default function LeftEvents({ activeIndex }) {
    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <ListGroup>

                <ListGroup.Item
                    as={Link}
                    action
                    to="/home-events-list"
                    className={`p-3 ${activeIndex == 5 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                     Events List
                </ListGroup.Item>


                <ListGroup.Item
                    as={Link}
                    action
                    to="/distinguished-lectures"
                    className={`p-3 ${activeIndex == 0 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    Distinguished Lectures
                </ListGroup.Item>

                <ListGroup.Item
                    as={Link}
                    action
                    to="/conferences"
                    className={`p-3 ${activeIndex == 1 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    Conferences
                </ListGroup.Item>

                <ListGroup.Item
                    as={Link}
                    action
                    to="/technical-talks"
                    className={`p-3 ${activeIndex == 2 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    Technical Talks
                </ListGroup.Item>

                <ListGroup.Item
                    as={Link}
                    action
                    to="/workshops"
                    className={`p-3 ${activeIndex == 3 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    Workshops
                </ListGroup.Item>

                <ListGroup.Item
                    as={Link}
                    action
                    to="/institute-events"
                    className={`p-3 ${activeIndex == 4 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    Institute Events
                </ListGroup.Item>
            </ListGroup>
        </Tab.Container>
    );
}
